import { createApp } from 'vue'
import '@/assets/styles/style.scss'
import "vue3-openlayers/styles.css"
import 'swiper/css'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { registerOpenLayers } from '@/utils/openlayers'



import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { registerSW } from 'virtual:pwa-register'
import { useAuthStore } from '@/stores/authStore'

// Инициализация PWA
const updateSW = registerSW({
  onNeedRefresh() {
    // Автоматически обновляем без подтверждения
    updateSW(true);
  },
  onOfflineReady() {
    console.log('Приложение готово для работы оффлайн');
  },
  immediate: false // Отключаем автоматическую проверку при регистрации
});

// Проверка обновлений при запуске приложения
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(reg => {
    reg.update().then(() => {
      console.log('Проверка обновлений выполнена');
    });
  });
}

// Создание и настройка приложения
const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// Инициализация хранилищ
useAuthStore(pinia).initializeAuth()

registerOpenLayers(app)
// Основные зависимости
app.use(pinia)
app.use(router)

// Монтирование приложения
app.mount('#app')
